import { render } from "./AuthFooter.vue?vue&type=template&id=336cc90f"
import script from "./AuthFooter.vue?vue&type=script&lang=js"
export * from "./AuthFooter.vue?vue&type=script&lang=js"
script.render = render

export default script